import type { Block } from "../contract/types";
import { BlockRenderer } from "../blocks/BlockRenderer";
import type { BlockEventSink } from "../blocks/types";

/** Los presets componen átomos: se pintan con el mismo renderer que el stream. */
export function Blocks({ blocks, emit, interactive }: { blocks: Block[]; emit: BlockEventSink; interactive: boolean }) {
  return (
    <div className="preset__blocks">
      {blocks.map((block) => (
        <BlockRenderer key={block.id} block={block} emit={emit} interactive={interactive} />
      ))}
    </div>
  );
}

export default Blocks;
